import { loginSchema, type AtendenteDTO } from '@viniko/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoWhatsapp } from '../componentes/LogoWhatsapp';
import { post } from '../lib/api';
import { chaves } from '../lib/consultas';
import './login.css';

const FOTOS = ['/login-fundo-1.jpg', '/login-fundo-2.jpg', '/login-fundo-3.jpg'];
const TROCA_MS = 6000;

export function Login() {
  const qc = useQueryClient();
  const navegar = useNavigate();
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function entrar(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const dados = Object.fromEntries(new FormData(e.currentTarget));
    const r = loginSchema.safeParse(dados);
    if (!r.success) return setErro(r.error.issues[0]?.message ?? 'Confira os dados.');
    setEnviando(true);
    setErro(null);
    try {
      const eu = await post<AtendenteDTO>('/api/auth/login', r.data);
      qc.setQueryData(chaves.eu, eu);
      navegar('/conversas', { replace: true });
    } catch (err) {
      setErro((err as Error).message);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main className="login">
      <Carrossel />
      <section className="login-lado">
        <form className="login-cartao" onSubmit={entrar} noValidate>
          <img
            className="login-logo"
            src="/logo-viniko.webp"
            alt="Viniko Loja"
            width={600}
            height={358}
          />
          <label className="login-campo">
            <span>E-mail</span>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="voce@viniko.com.br"
              autoComplete="username"
              required
            />
          </label>
          <label className="login-campo">
            <span>Senha</span>
            <input
              id="senha"
              name="senha"
              type="password"
              placeholder="••••••••••"
              autoComplete="current-password"
              required
            />
          </label>
          {erro && (
            <div className="login-erro" role="alert">
              {erro}
            </div>
          )}
          <button className="login-entrar" disabled={enviando}>
            {enviando ? 'Entrando…' : 'Entrar'}
          </button>
          <div className="login-marca">
            <LogoWhatsapp tamanho={18} />
            <span>ChatFlow</span>
          </div>
        </form>
      </section>
    </main>
  );
}

function Carrossel() {
  const [atual, setAtual] = useState(0);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const t = setInterval(() => setAtual((i) => (i + 1) % FOTOS.length), TROCA_MS);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="login-foto" aria-hidden>
      {FOTOS.map((src, i) => (
        <div
          key={src}
          className={i === atual ? 'login-slide ativo' : 'login-slide'}
          style={{ backgroundImage: `url('${src}')` }}
        />
      ))}
      <div className="login-pontos">
        {FOTOS.map((src, i) => (
          <span key={src} className={i === atual ? 'ativo' : ''} />
        ))}
      </div>
    </div>
  );
}
